module.exports = __webpack_public_path__ + "img/award_img01.b0e8fa53.jpg";